/*
 * This code was generated with assistance from GitHub Copilot.
 * De-bundled from react-dxd-components@0.1.33 compiled dist/index.js (webpack module id 4).
 */
import * as React from 'react';

export interface DetailsProps {
  /** A unique identifier */
  id: string;
  /** Optional text to display below the input to provide additional clarification or guidance */
  helperText?: string | null;
  /** Adds red styling to show that value is invalid */
  invalid?: boolean | string;
  /** Optional text to provide information about why input is invalid */
  errorMessage?: string;
  /** Optional flag to suppress helper Text on error Message */
  suppressHelpTextOnError?: boolean;
}

const Details = ({
  id,
  helperText = null,
  invalid = false,
  errorMessage = '',
  suppressHelpTextOnError = false,
}: DetailsProps) => (
  <>
    {helperText && (!suppressHelpTextOnError || !errorMessage) && (
      <span className="Field-detail" id={`${id}-detail`}>
        {helperText}
      </span>
    )}
    {invalid && <span className="Field-error">{errorMessage}</span>}
  </>
);

export default Details;


